
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import { useAuth } from '../../../Hooks/UseAuth'
import useTranslation from '../../../Hooks/UseTranslation'
import { useProgrammation } from '@/Hooks/UseProgrammation'

import { addRestrictionComment } from '../../../Services/ProgrammationManagerService'
import { updateTaskDateAction } from '../../../Redux/Actions/ProgrammationManagerActions'

import './CommentInput.scss'

interface Props {
  taskId: string
  restrictionId: string
  onCommentsUpdated: (comments: any[]) => void
  readOnly?: boolean
}

const RestrictionCommentInput = ({ taskId, restrictionId, onCommentsUpdated, readOnly }: Props) => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { setEditingItem } = useProgrammation()

  const { userData } = useAuth()

  const [ comment, setComment ] = useState('')
  const [ saving, setSaving ] = useState(false)

  const handleComment = async () => {

    setEditingItem(true)

    const message = comment.trim()

    setSaving(true)

    const [ error, data ] = await addRestrictionComment(taskId, restrictionId, message)

    setComment('')
    setSaving(false)
    setEditingItem(false)

    if (error) {

      console.error(error)
      return
    }

    onCommentsUpdated(data.comments)

    await dispatch(updateTaskDateAction(data.task))
  }

  if (!userData) return null

  return (
    <div className='comment-input'>
      <div className="user-texts">
        <textarea
          className="user-texts-input"
          rows={3}
          placeholder="Escribe un comentario"
          value={comment}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setComment(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && e.shiftKey) {
              e.preventDefault()
              if (comment.trim().length > 0 && !readOnly) {
                handleComment()
              }
            }
          }}
          disabled={readOnly || saving}
        />
        <button className="user-texts-submit"
          onClick={() => handleComment()}
          disabled={comment.length === 0 || readOnly || saving}
        >
          {!saving && t('PROGRAMMATION_MANAGER:AddCommentButton')}
          {saving && t('PROGRAMMATION_MANAGER:AddingCommentButton')}
        </button>
      </div>
    </div>
  )
}

export default RestrictionCommentInput
